import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { API } from "@/lib/api";

export default function Login() {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex bg-zinc-950 text-zinc-100 font-[Inter]">
      {/* Left brand panel */}
      <div className="hidden lg:flex w-1/2 flex-col justify-between p-14 border-r border-zinc-800 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage: "radial-gradient(circle at 1px 1px, #000 1px, transparent 0)",
            backgroundSize: "22px 22px",
          }}
        />
        <div className="relative flex items-center gap-4">
          <img
            src={`${API}/assetlibrary/public/signin-logo.png`}
            alt="Dowdens Group"
            data-testid="login-logo"
            style={{ width: "150px", height: "auto" }}
            className="object-contain"
          />
          <span className="font-[Outfit] font-black text-[30px] tracking-tight">Marketing Hub</span>
        </div>
        <div className="relative">
          <h1 className="font-[Outfit] text-4xl xl:text-5xl font-black tracking-wide text-zinc-50 leading-[1.15]">
            The operating system for the <span style={{ color: "#005596" }}>Dowdens Group</span> web presence.
          </h1>
          <p className="mt-6 text-zinc-400 text-base max-w-md leading-relaxed">
            One hub to build, optimise and maintain dowdens.com.au, dowdensgroup.com.au and airstart.com.au — powered by Claude AI.
          </p>
        </div>
        <div className="relative flex gap-6 text-xs font-bold uppercase tracking-[0.2em] text-zinc-600">
          <span>SEO</span><span>GEO / AEO</span><span>FAQ</span><span>CTA</span><span>Builder</span>
        </div>
      </div>

      {/* Right — Google sign-in */}
      <div className="flex-1 flex items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="w-full max-w-sm"
        >
          <h2 className="font-[Outfit] text-2xl font-bold tracking-tight">Sign in</h2>
          <p className="text-sm text-zinc-500 mt-1 mb-8">Use your Dowdens Group Google account to continue.</p>

          <button
            data-testid="google-signin-btn"
            onClick={signIn}
            className="w-full bg-white text-[#18181b] font-medium rounded-lg px-4 py-3 flex items-center justify-center gap-3 border border-zinc-700 shadow-sm hover:bg-[#f7f7f7] transition-colors focus:ring-2 focus:ring-indigo-400 focus:outline-none"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.23 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.11a6.6 6.6 0 0 1 0-4.22V7.05H2.18a11 11 0 0 0 0 9.9l3.66-2.84z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.05l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
            </svg>
            Continue with Google
          </button>

          <div className="mt-6 flex items-start gap-2 text-xs text-zinc-500 bg-zinc-900 border border-zinc-800 rounded-lg p-3">
            <ShieldCheck className="h-4 w-4 text-indigo-400 flex-shrink-0 mt-0.5" />
            <span data-testid="domain-restriction-note">
              Access is restricted to Dowdens Group accounts: dowdens.com.au, dowdensgroup.com.au and airstart.com.au.
            </span>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
